import canUndo from '@gamepark/brigands/canUndo'
import GameView from '@gamepark/brigands/GameView'
import {arrestPartners} from '@gamepark/brigands/moves/ArrestPartners'
import {betGold} from '@gamepark/brigands/moves/BetGold'
import {drawEventInView} from '@gamepark/brigands/moves/DrawEvent'
import {gainGold} from '@gamepark/brigands/moves/GainGold'
import {judgePrisoners} from '@gamepark/brigands/moves/JudgePrisoners'
import {kickOrNotInView} from '@gamepark/brigands/moves/KickOrNot'
import {moveOnDistrictResolved} from '@gamepark/brigands/moves/MoveOnDistrictResolved'
import {moveOnNextPhase} from '@gamepark/brigands/moves/MoveOnNextPhase'
import {movePartner} from '@gamepark/brigands/moves/MovePartner'
import MoveType from '@gamepark/brigands/moves/MoveType'
import MoveView from '@gamepark/brigands/moves/MoveView'
import {placePartnerInView} from '@gamepark/brigands/moves/PlacePartner'
import {placePatrol} from '@gamepark/brigands/moves/PlacePatrol'
import {placeToken} from '@gamepark/brigands/moves/PlaceToken'
import {playHeadStart} from '@gamepark/brigands/moves/PlayHeadStart'
import {resolveStealToken} from '@gamepark/brigands/moves/ResolveStealToken'
import {revealGoldsInView} from '@gamepark/brigands/moves/RevealGolds'
import {revealKickOrNotView} from '@gamepark/brigands/moves/RevealKickOrNot'
import {revealPartnersDistrictsInView} from '@gamepark/brigands/moves/RevealPartnersDistricts'
import {solvePartner} from '@gamepark/brigands/moves/SolvePartner'
import {spareGoldOnTreasure} from '@gamepark/brigands/moves/SpareGoldOnTreasure'
import {takeBackPartner} from '@gamepark/brigands/moves/TakeBackPartner'
import {takeToken} from '@gamepark/brigands/moves/TakeToken'
import {tellYouAreReady} from '@gamepark/brigands/moves/TellYouAreReady'
import {throwDice} from '@gamepark/brigands/moves/ThrowDice'
import PlayerRole from '@gamepark/brigands/types/PlayerRole'
import {Action, Rules, Undo} from '@gamepark/rules-api'
import SetSelectedPartner, { resetSelectedPartner, ResetSelectedPartner, setSelectedPartner } from './localMoves/SetSelectedPartner'
import SetSelectedPatrol, { resetSelectedPatrol, ResetSelectedPatrol, setSelectedPatrol } from './localMoves/SetSelectedPatrol'
import SetSelectedHeadStart, { resetSelectedHeadStart, ResetSelectedHeadStart, setSelectedHeadStart } from './localMoves/SetSelectedHeadStart'
import SetSelectedTokenInHand, { resetSelectedTokenInHand, ResetSelectedTokenInHand, setSelectedTokenInHand } from './localMoves/SetSelectedTokenInHand'
import SetSelectedTokensInBank, { resetSelectedTokensInBank, ResetSelectedTokensInBank, setSelectedTokensInBank } from './localMoves/SetSelectedTokensInBank'

type LocalMove = MoveView | SetSelectedPartner | ResetSelectedPartner | SetSelectedTokensInBank | ResetSelectedTokensInBank | SetSelectedTokenInHand | ResetSelectedTokenInHand
| SetSelectedPatrol | ResetSelectedPatrol | SetSelectedHeadStart | ResetSelectedHeadStart

export default class BrigandsView extends Rules<GameView, MoveView, PlayerRole> implements Undo<GameView, MoveView, PlayerRole> {

  play(move: LocalMove): MoveView[] {
    switch (move.type) {
      case MoveType.DrawEvent:
        drawEventInView(this.state, move)
        break
      case MoveType.PlacePartner:
        placePartnerInView(this.state, move)
        break
      case MoveType.PlaceToken:
        placeToken(this.state, move)
        break
      case MoveType.TellYouAreReady:
        tellYouAreReady(this.state, move)
        break
      case MoveType.MoveOnNextPhase:
        moveOnNextPhase(this.state)
        break
      case MoveType.PlacePatrol:
        placePatrol(this.state, move)
        break
      case MoveType.RevealPartnersDistricts:
        revealPartnersDistrictsInView(this.state, move)
        break
      case MoveType.ThrowDice:
        throwDice(this.state, move)
        break
      case MoveType.TakeToken:
        takeToken(this.state, move)
        break
      case MoveType.TakeBackPartner:
        takeBackPartner(this.state, move)
        break
      case MoveType.SpareGoldOnTreasure:
        spareGoldOnTreasure(this.state, move)
        break
      case MoveType.SolvePartner:
        solvePartner(this.state, move)
        break
      case MoveType.GainGold:
        gainGold(this.state, move)
        break
      case MoveType.BetGold:
        betGold(this.state, move)
        break
      case MoveType.MoveOnDistrictResolved:
        moveOnDistrictResolved(this.state, move)
        break
      case MoveType.ArrestPartners:
        arrestPartners(this.state)
        break
      case MoveType.ResolveStealToken:
        resolveStealToken(this.state, move)
        break
      case MoveType.KickOrNot:
        kickOrNotInView(this.state, move)
        break
      case MoveType.RevealKickOrNot:
        revealKickOrNotView(this.state, move)
        break
      case MoveType.MovePartner:
        movePartner(this.state, move)
        break
      case MoveType.JudgePrisoners:
        judgePrisoners(this.state)
        break
      case MoveType.PlayHeadStart :
        playHeadStart(this.state, move)
        break
      case MoveType.RevealGolds:
        revealGoldsInView(this.state, move)
        break
      case 'SetSelectedPartner':
        setSelectedPartner(this.state, move)
        break
      case 'ResetSelectedPartner':
        resetSelectedPartner(this.state)
        break
      case 'SetSelectedTokensInBank':
        setSelectedTokensInBank(this.state, move)
        break
      case 'ResetSelectedTokensInBank':
        resetSelectedTokensInBank(this.state)
        break
      case 'SetSelectedTokenInHand':
        setSelectedTokenInHand(this.state, move)
        break
      case 'ResetSelectedTokenInHand':
        resetSelectedTokenInHand(this.state)
        break
      case 'SetSelectedPatrol':
        setSelectedPatrol(this.state, move)
        break
      case 'ResetSelectedPatrol':
        resetSelectedPatrol(this.state)
        break
      case 'SetSelectedHeadStart':
        setSelectedHeadStart(this.state)
        break
      case 'ResetSelectedHeadStart':
        resetSelectedHeadStart(this.state)
        break
    }
    return []
  }

  canUndo(action: Action<MoveView, PlayerRole>, consecutiveActions: Action<MoveView, PlayerRole>[]): boolean {
    return canUndo(action, consecutiveActions)
  }

}